import { fleetEnvironment } from '../fleet-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { fleetJwtSchema } from '../schemas/fleet-jwt.schema';
import { fromFetch } from 'rxjs/fetch';

/**
 * Fetches a Fleet JWT token
 * @returns The Fleet JWT token
 */
export function postWebAuthenticate(this: unknown, token: string) {
  return fromFetch(
    new Request(fleetEnvironment.resolve(this).webAuthenticateUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
      },
      body: JSON.stringify({
        tokenExpression: `token=${token}`,
      }),
    })
  ).pipe(selectData(fleetJwtSchema));
}
